<script>
    import {onDestroy, onMount} from 'svelte';
    import {fade} from 'svelte/transition';
    import {PRConnect, PRFile} from "@projectroom/ui-lib";
    import {navigateTo} from 'svelte-router-spa';
	import { _ } from 'svelte-i18n';
	import { accessToken } from './store/auth-store';
	import { Card, Button, Dialog } from '../lib/ui';


    let loginInfo = { "emailId" : "", "password" : ""};
    let errorMesage = "";
	let dosiDuplicateFlag;
	let loginUrl = `${window.location.origin}/login`;

    // shadcn 인풋/소셜 버튼 공용 클래스
    const inputCls = "tw-flex tw-h-11 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-text-foreground placeholder:tw-text-muted-foreground focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring disabled:tw-opacity-50";
    const snsBase = "tw-flex tw-h-11 tw-w-full tw-items-center tw-justify-center tw-gap-2.5 tw-rounded-md tw-text-sm tw-font-semibold tw-transition-opacity tw-cursor-pointer hover:tw-opacity-90";
    const googleBtn = snsBase + " tw-border tw-border-[#dadce0] tw-bg-white tw-text-[#3c4043]";
    const kakaoBtn = snsBase + " tw-bg-[#FEE500] tw-text-[#191600]";

    onMount(() => {
        let urlParams = new URLSearchParams(window.location.search);
        let statusCode = urlParams.get("statusCode");
        if( statusCode === "DUPLICATED") {
            errorMesage = $_('project.default.54_Login');
        } else if ( statusCode === "DUPLICATED_DOSI") {
			dosiDuplicateFlag = true;
		}
    });

    const validEmail = () => {
        const regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
        return loginInfo.emailId.match(regex) == null;
    }

    const doLogin = () => {
        if (validEmail()) {
            errorMesage = $_('project.default.55');
            return;
        }
        PRConnect.send("/api/Auth/login", loginInfo, data => {
            if( data.result.status === "success") {
				accessToken.set(data.result.accessToken);
                navigateTo("/main");
            } else if (data.result.status === "required") {
                navigateTo(`${data.result.targetUrl}?${data.result.authToken}`);
            }
        }, error => {
            if (error.header.code === "fail") {
                errorMesage = error.header.message;
            }
        });
    }

    const doSNSLogin = (provider) => {
		const userAgent = navigator.userAgent;
		if (userAgent.includes("KAKAO") || userAgent.includes("Instagram")) {
			alert($_('project.default.56'));
			return;
		}
        switch(provider) {
            case "google":
				location.href =
				`https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${location.origin}/auth/callback/google&prompt=consent&response_type=code&client_id=478826573645-0ahmehhpvmq053jh27c4p646bgak3b8s.apps.googleusercontent.com&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile`;
				break;
			case "kakao":
				location.href =
				`https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=dc3054523b05087d5f4582c876e1d3b9&redirect_uri=${location.origin}/auth/callback/kakao`;
				break;
			case "dosi":
				let redirectUri = `${location.origin}/auth/callback/dosi`;
				redirectUri = encodeURIComponent(redirectUri);
				location.href =
				`https://members.dosi.world/?mode=oauth&client_id=MDXUb_U9CRBdUA0j2S3e&redirect_uri=${redirectUri}`;
				break;
        }
    }
</script>

<div class="tw-flex tw-min-h-screen tw-justify-center tw-bg-background tw-px-4 tw-pb-20 tw-pt-24 tw-font-sans tw-text-foreground sm:tw-pt-28" in:fade>
    <div class="tw-w-full tw-max-w-[420px]">
        <Card class="tw-p-8 sm:tw-p-10">
            <h1 class="tw-mb-1 tw-text-center tw-text-2xl tw-font-bold tw-text-foreground">{$_('project.default.57')}</h1>

            {#if errorMesage}
                <div class="tw-mt-4 tw-rounded-md tw-bg-destructive/10 tw-px-3 tw-py-2 tw-text-center tw-text-sm tw-font-medium tw-text-destructive">{errorMesage}</div>
            {/if}

            <form class="tw-mt-6 tw-space-y-4" on:submit|preventDefault={doLogin}>
                <div>
                    <label for="login-email" class="tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground">{$_('project.default.58')}</label>
                    <input id="login-email" type="email" maxlength="256" placeholder={$_('project.default.59')} bind:value={loginInfo.emailId} class={inputCls} />
                </div>
                <div>
                    <label for="login-pw" class="tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground">{$_('project.default.60')}</label>
                    <input id="login-pw" type="password" maxlength="256" placeholder={$_('project.default.61')} bind:value={loginInfo.password} class={inputCls} />
                </div>

                <div class="tw-flex tw-items-center tw-justify-end tw-gap-3 tw-text-xs">
                    <button type="button" class="tw-cursor-pointer tw-bg-transparent tw-text-muted-foreground hover:tw-text-foreground" on:click={()=>navigateTo("/find-email")}>{$_('project.default.62')}</button>
                    <span class="tw-text-border">|</span>
                    <button type="button" class="tw-cursor-pointer tw-bg-transparent tw-text-muted-foreground hover:tw-text-foreground" on:click={()=>navigateTo("/find-password")}>{$_('project.default.63')}</button>
                </div>

                <Button type="submit" size="lg" class="tw-w-full">{$_('project.default.64')}</Button>
            </form>

            <div class="tw-my-6 tw-flex tw-items-center tw-gap-3">
                <div class="tw-h-px tw-flex-1 tw-bg-border"></div>
                <span class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wider tw-text-muted-foreground">Or</span>
                <div class="tw-h-px tw-flex-1 tw-bg-border"></div>
            </div>

            <div class="tw-space-y-2.5">
                <button type="button" class={googleBtn} on:click={()=> doSNSLogin("google")}>
                    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
                    {$_('project.default.65')}
                </button>
                <button type="button" class={kakaoBtn} on:click={()=> doSNSLogin("kakao")}>
                    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" fill="#191600"><path d="M12 3C6.48 3 2 6.58 2 11c0 2.84 1.9 5.33 4.75 6.74-.2.72-.72 2.62-.83 3.03-.13.51.19.5.4.36.16-.11 2.6-1.77 3.66-2.49.66.1 1.34.15 2.02.15 5.52 0 10-3.58 10-8S17.52 3 12 3z"/></svg>
                    {$_('project.default.66')}
                </button>
            </div>

            <p class="tw-mt-6 tw-text-center tw-text-sm tw-text-muted-foreground">
                {$_('project.default.67')}
                <button type="button" class="tw-cursor-pointer tw-bg-transparent tw-font-semibold tw-text-primary hover:tw-underline" on:click={()=>navigateTo("/join")}>{$_('project.default.68')}</button>
            </p>
        </Card>
    </div>
</div>

<Dialog open={dosiDuplicateFlag} title="혹시 이미 아바톡 회원이신가요?" on:close={()=> dosiDuplicateFlag = false}>
    <p class="tw-m-0 tw-text-sm tw-text-muted-foreground">해당 계정은 이미 가입이 되어있어요.</p>
    <div class="tw-mt-4 tw-rounded-lg tw-border tw-border-border tw-bg-muted/40 tw-p-4">
        <div class="tw-text-sm tw-font-semibold tw-text-foreground">로그인이 안된다면 이렇게 해보세요!</div>
        <ul class="tw-mt-2 tw-list-disc tw-space-y-1 tw-pl-5 tw-text-sm tw-text-muted-foreground">
            <li>기존에 가입한 계정으로 아바톡에 <a class="tw-font-medium tw-text-primary tw-underline" href={loginUrl}>로그인</a>합니다.</li>
            <li>로그인한 후 요금제 혹은 계정관리에서 도시앱 연동을 합니다.</li>
        </ul>
        <div class="tw-mt-3 tw-text-sm">
            <a class="tw-font-medium tw-text-primary tw-underline" href="https://avatalk.gitbook.io/avatalk/undefined-2/dosi#id-2.-dosi" target="_blank" rel="noreferrer">도시앱 연동방법을 알고 싶다면?</a>
        </div>
    </div>
</Dialog>
